<template>
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-card flat class="elevation-2 mt-4">
          <v-toolbar flat dark :class="indicator.class">
            <v-toolbar-title>{{ indicator.message }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="sendCaptcha">
              <img :src="data.image" width="400px" height="100%" alt="captcha" />
              <v-text-field
                name="captcha"
                label="Введите текст" type="text" v-model="captcha">
              </v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :color="indicator.class">Отправить</v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  </template>

<script>
export default {
  mounted() {
        this.getCaptcha()
    },
	data() {
		return {
			captcha: '',
			indicator: {
				class: 'primary',
				message: 'Введите текст с картинки'
			},
      isInProgress: false,
      data: null,
		}
	},
	computed: {},
	methods: {
    getCaptcha() {
      this.isInProgress = true
      this.$store.dispatch('GET_CAPTCHA')
      .then((result) => {
        this.data = result
        this.isInProgress = false
      })
      .catch( (err) => {
        console.log(err)
        this.isInProgress = false
      })
    },
    sendCaptcha () {
      this.$store.dispatch('SEND_CAPTCHA', { id: this.data.id, captcha: this.captcha })
			.then( () => {
				this.$router.push('/login')
			})
			.catch(err => {
				throw err
			})
    }
	},
}
</script>

